import { createSidebarRequest } from '@/features/sidebar';
import type { AddFundsData, AddFundsResult, AddFundsCloseData } from './add-funds-panel';

export const ADD_FUNDS_SIDEBAR_ID = 'flex-add-funds';

export const addFundsRequest = createSidebarRequest<AddFundsData, AddFundsResult, AddFundsCloseData>(
  ADD_FUNDS_SIDEBAR_ID,
);
